/**
 * Shared counter for generating unique IDs across input components.
 *
 * Using a single shared counter avoids ID collisions when multiple
 * input component types are rendered on the same page.
 */
let idCounter = 0;

/**
 * Generate a unique ID with the given prefix.
 *
 * @param prefix - A string prefix for the generated ID (e.g. 'textfield', 'select')
 * @returns A unique string in the form `${prefix}-${number}`
 */
export function generateId(prefix: string): string {
  return `${prefix}-${++idCounter}`;
}
